import React, { useState } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { AuthContext } from "../../contexts/authContext";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Button, Grid, Container, Box } from "@material-ui/core";
import Hidden from '@material-ui/core/Hidden';
import PlayIcon from '@material-ui/icons/PlayCircleFilled';

// import ModalVideo from 'react-modal-video';
// import 'react-modal-video/scss/modal-video.scss';
import VideoModal from '../../components/videoModal';

import PltwNavBar from "../../common/pltwNavBar";

import { recycle, videoBackground, zeroWasteLogo } from '../../common/images';
import { firstCategory, secondCategory, thirdCategory, fourthCategory } from '../../common/categoryImages';
import { welcome1, welcome2, welcome3, welcome4 } from './constants';
import { additionalInfo } from "../loginPage/constants";

import './welcome-styles.scss';




const useStyles = makeStyles(() => ({
  card: {
    padding: '10px 0px',
    margin: '0px 15px',
    // border: '1px solid black',
    // border: '4px solid transparent',
    // borderImage: 'linear-gradient(left, #99d6ce 15%, #f2642f 50%, #f8c12c 90%) 30'
  },
  videoButton: {
    fontSize: '20px',
    marginTop: '20px',
    color: 'white',
    border: '1px solid white',
    padding: '15px 30px',
    '&:hover': {
      backgroundColor: 'white',
      color: 'black',
      border: '1px solid black'
    },
    '@media (max-width: 959px)': {
    // backgroundColor: '#0d894b'
},
  },
  playIcon: {
    marginRight: '10px'
  }
}));

const Welcome = ({ history }) => {

  const classes = useStyles();

  const [isOpen, setOpenModal] = useState(false);

  const toggleModal = () => {
    setOpenModal(!isOpen)
  };

  return (
      <AuthContext.Consumer>{ (context)=>{
        const { isLoggedIn } = context
        return(
            isLoggedIn ?
                <div className='category-container'>
                  <Grid container spacing={3} alignItems="center" justify="space-around">


                    <VideoModal handleClose={toggleModal} open={isOpen} />

                    {/*<ModalVideo channel='youtube' isOpen={isOpen} videoId='B-OYPINDDig' onClose={toggleModal} />*/}

                    <Grid item xs={12} style={{ paddingBottom: '0px' }}>
                      <PltwNavBar />
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: '0px' }}>
                      <div className='zeroWaste-container'>
                        <img src={zeroWasteLogo} className='zeroWaste-logo' alt='zero waste' />
                      </div>
                    </Grid>

                    <Container>
                      <Box pt={3}>
                        <Grid item xs={12} style={{ padding: '12px 0px' }}>
                          <div className='info'>
                            <h2>Experience Real-world Learning With PLTW</h2>
                            <p>{welcome1}</p>
                            <p>{welcome2}</p>
                          </div>
                        </Grid>
                      </Box>
                    </Container>

                    <Grid item xs={12}>
                      <div className='outer-video-div'>
                        <Hidden smDown>
                          <div className='video-div' style={{ backgroundImage: `url(${videoBackground})` }} />
                        </Hidden>
                        <div className='video-info'>
                          <h1>A special welcome from Dr. Vince Bertram,</h1>
                          <h1>PLTW president and CEO</h1>
                          <Button onClick={toggleModal} className={classes.videoButton}>
                            <PlayIcon fontSize="large" className={classes.playIcon} />WATCH NOW
                          </Button>
                        </div>
                      </div>
                    </Grid>

                  </Grid>


                  <Grid item xs={12}>
                    <div className='recycle-line'>
                      <img className='recycle-logo' src={recycle} alt='recycle logo' />
                    </div>
                  </Grid>


                  <Container>
                    <Grid container>
                      <Grid item xs={12}>
                        <div className='info2'>
                          <h3>An Engaging Experience for All K-12 Students</h3>
                          <p>{welcome4}</p>
                        </div>
                      </Grid>

                      <Grid item xs={12}>
                        <div className='module-cards'>
                          <img src={firstCategory} onClick={() => history.push('/home/1')} alt="K - 2" />
                          <img src={secondCategory} onClick={() => history.push('/home/2')} alt="3 - 5" />
                          <img src={thirdCategory} onClick={() => history.push('/home/3')} alt="6 - 8" />
                          <img src={fourthCategory} onClick={() => history.push('/home/4')} alt="9 - 12" />
                        </div>
                      </Grid>
                    </Grid>
                  </Container>


                  <Grid item xs={12}>
                    <Box pb={5}>
                      <div className='additional-info'>
                        <p>{additionalInfo}</p>
                      </div>
                    </Box>
                  </Grid>

                </div>
                :<div><Redirect to='/' /></div>
        )
      }}
      </AuthContext.Consumer>
  );
};

export default withRouter(Welcome);
